export const shouldShowMessageActions = ({
  isHovered = false,
  isMobile = false,
  isShowingTimestamp = false,
}) => {
  if (isMobile) {
    return true;
  }

  return isHovered;
};

export const shouldShowCopyAction = ({
  isHovered = false,
  isMobile = false,
  isShowingTimestamp = false,
  messageType = "",
}) => {
  if (messageType === "audio") {
    return false;
  }

  return (
    shouldShowMessageActions({
      isHovered,
      isMobile,
      isShowingTimestamp,
    }) && isShowingTimestamp
  );
};
